(function (module) {
    'use strict';

    function Admin($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('root.admin', {
                url: '/admin',
                abstract: true,
                resolve: {
                    isRocket: function (Store, $state) {
                        const currentAccount = Store.getCurrentAccount();
                        if (!currentAccount.rocket) {
                            $state.go('root');
                        }

                    }
                }
            });

        $translatePartialLoaderProvider.addPart('/js/admin');

    }

    module.config(Admin);

})(angular.module('rocket.components'));
